import { ScopeProvider } from 'jotai-scope'
import { FC, PropsWithChildren } from 'react'

import { quoteSyncStatusAtom } from './quoteSync.atoms'

/**
 * Pins the quote's sync status to one editor, so the header, the content, the
 * inspector and the modals below share it and nothing outside can see it. Cube
 * gives each editor its own jotai store already, so this is what keeps that
 * true if a quote editor ever mounts somewhere else.
 */
export const QuoteSyncProvider: FC<PropsWithChildren> = ({ children }) => (
  <ScopeProvider atoms={[quoteSyncStatusAtom]}>{children}</ScopeProvider>
)
